import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { sendApiRequest } from "../utils/api";
import { FaChevronRight, FaEnvelope, FaPhone } from "react-icons/fa";
import LogoLoader from "./LogoLoader";

// replace with your logo
import Logo from "../assets/logo2.jpeg";

const CategoryExams = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      try {
        const categoryRes = await sendApiRequest(
          `api/exam-categories/${categoryId}`,
          {},
          "GET"
        );
        setCategory(categoryRes);

        const courseRes = await sendApiRequest(
          `api/exams/category/${categoryId}`,
          {},
          "GET"
        );
        setCourses(courseRes?.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [categoryId]);

  return (
    <div className="bg-[#1d3a80] min-h-screen font-[montserrat] ">
      {loading ? (
        <LogoLoader text="Loading courses..." />
      ) : (
        <>
          {/* ================= HEADER ================= */}
          <div className="px-2 py-3">
            <div className="max-w-3xl mx-auto flex flex-col items-center text-center text-white">

              {/* Logo */}
              <div className="w-28 h-28 rounded-full bg-white flex items-center justify-center shadow">
                <img
                  src={Logo}
                  alt="Logo"
                  className="w-20 h-20 object-contain"
                />
              </div>

              {/* Text Content */}
              <div>
                <h1 className="text-xl font-bold">
                  Shorthand Software Academy
                </h1>
                <p className="text-sm text-white/90 ">
                  shorthandsoftwareacademy@gmail.com
                </p>
                <p className="text-sm text-white/90">
                  +91 87872 24408
                </p>
              </div>

            </div>
          </div>




          {/* ================= CONTENT ================= */}
          <div className="bg-[#f5f7fb] rounded-t-3xl px-4 py-6 max-w-3xl mx-auto">

            {/* COURSE TITLE */}
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              {category?.title || "Available Courses"}
            </h2>

            {/* LIST */}
            {courses.map((course) => (
              <div
                key={course._id}
                onClick={() => navigate(`/exams/${course._id}`)}
                className="flex items-center gap-4 bg-white rounded-xl p-4 mb-4
                           shadow-sm hover:shadow-md transition cursor-pointer"
              >
                {/* ICON / IMAGE */}
                <img
                  src={course.thumbnail || "https://via.placeholder.com/60"}
                  alt={course.name}
                  className="w-12 h-12 object-contain"
                />

                {/* TEXT */}
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-gray-900">
                    {course.name}
                  </h3>

                  <p className="text-xs text-gray-500 line-clamp-1">
                    {course.description}
                  </p>

                  <p className="text-xs text-[#1f4fa3] font-medium mt-1">
                    ₹ {course.fee || 0} • {course.timingPeriod || 0} Days
                  </p>
                </div>

                {/* ARROW */}
                <FaChevronRight className="text-gray-400 text-sm" />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CategoryExams;
